import React from "react";
import { QUOTE_STATUSES, initials } from "./format";

// Mattoncini grafici condivisi tra area commerciali e Admin

export const StatusBadge = ({ status }) => {
  const s = QUOTE_STATUSES[status] || QUOTE_STATUSES.valutazione;
  return (
    <span
      className={`inline-flex items-center h-6 px-2.5 rounded-full text-[10px] font-montserrat font-bold uppercase tracking-wider whitespace-nowrap ${s.className}`}
    >
      {s.label}
    </span>
  );
};

export const Avatar = ({ name, size = "w-8 h-8 text-xs" }) => (
  <span
    className={`${size} shrink-0 rounded-full bg-[#0FB36B] text-white font-montserrat font-bold flex items-center justify-center`}
  >
    {initials(name)}
  </span>
);

export const Card = ({ title, actions, children, className = "", bodyClassName = "p-5" }) => (
  <section
    className={`bg-white rounded-md shadow-[0_1px_3px_rgba(10,31,68,0.08)] ${className}`}
  >
    {(title || actions) && (
      <div className="flex flex-wrap items-center justify-between gap-3 px-5 min-h-[56px] py-2 border-b border-gray-100">
        {title && (
          <h2 className="text-sm font-montserrat font-bold text-[#0A1F44]">{title}</h2>
        )}
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
    )}
    <div className={bodyClassName}>{children}</div>
  </section>
);

export const MetaLabel = ({ children }) => (
  <p className="text-[10px] font-montserrat font-semibold uppercase tracking-wider text-[#0A1F44]/60 mb-1">
    {children}
  </p>
);

const BTN_BASE =
  "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md text-xs font-montserrat font-bold uppercase tracking-wider transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

export const btnPrimary = `${BTN_BASE} bg-[#F4C542] hover:bg-[#e6b838] text-[#0A1F44]`;
export const btnDark = `${BTN_BASE} bg-[#0A1F44] hover:bg-[#0d2855] text-white`;
export const btnSoft = `${BTN_BASE} bg-[#0A1F44]/5 hover:bg-[#0A1F44]/10 text-[#0A1F44]`;
